import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import ReportView from "@/components/ReportView";
import { Link2, Users, LayoutDashboard, PlayCircle, Mail, FileBadge } from "lucide-react";

const NAV_LINKS = [
  { to: "/me", label: "Dashboard", icon: LayoutDashboard, testId: "nav-me-dashboard" },
  { to: "/me/students", label: "My Students", icon: Users, testId: "nav-me-students" },
  { to: "/me/link", label: "My Link", icon: Link2, testId: "nav-me-link" },
  { to: "/me/inbox", label: "Inbox", icon: Mail, testId: "nav-me-inbox" },
  { to: "/me/sample-report", label: "Sample Report", icon: FileBadge, testId: "nav-me-sample-report" },
  { to: "/me/demo", label: "Launch Demo", icon: PlayCircle, testId: "nav-me-demo" },
];

export default function MarketingSampleReport() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/marketing/sample-report")
      .then((res) => setReport(res.data))
      .catch(() => setReport(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardShell links={NAV_LINKS} activePath="/me/sample-report">
      <h1 className="font-heading text-2xl font-bold text-slate-900 mb-6" data-testid="marketing-sample-report-heading">Sample Report</h1>
      {loading && <p className="text-sm text-slate-400" data-testid="sample-report-loading">Loading sample report…</p>}
      {!loading && !report && <p className="text-sm text-slate-400" data-testid="sample-report-empty">No sample report available yet.</p>}
      {!loading && report && <ReportView report={report} isSample />}
    </DashboardShell>
  );
}
